module.exports = __webpack_public_path__ + "static/flags/AU-14d536e6deb7d9c4e78f86d09493edec.gif";